<template>
	<div>
		<!-- <changeLang /> -->
		<div id="login">
			<md-card class="md-elevation-5 card" v-bind:class="{ shakingcard: error }">
				<md-card-header class="flex" data-background-color="purple">
					<h3 class="center">{{ $t("password-forgotten") }}</h3>
				</md-card-header>
				<md-card-content class="card-content">
					<div class="center" style="width: 80%">
						<div>
							<md-field>
								<md-icon v-bind:style="{ color: error ? 'red' : 'grey' }"> account_circle </md-icon>
								<md-input
									v-model="usernameoremail"
									:placeholder="$t('usernameoremail')"
									required
									@input="error = false"
								/>
							</md-field>
						</div>

						<div v-if="$route.params.conf_code">
							<md-field :class="validPassword || !password ? '' : 'md-invalid'">
								<md-icon
									v-bind:style="{
										color: error && (password != re_password || !password) ? 'red' : 'grey'
									}"
									>vpn_key</md-icon
								>
								<md-input
									name="password"
									v-model="password"
									:placeholder="$t('password')"
									type="password"
								/>
								<span class="md-error">{{ $t("password-error") }}</span>
							</md-field>

							<md-field :class="validRePassword || !re_password ? '' : 'md-invalid'">
								<md-icon
									v-bind:style="{
										color: error && (password != re_password || !password) ? 'red' : 'grey'
									}"
									>vpn_key</md-icon
								>
								<md-input
									name="password"
									v-model="re_password"
									:placeholder="$t('retype-password')"
									type="password"
								/>
								<span class="md-error">{{ $t("re-password-error") }}</span>
							</md-field>
						</div>

						<div class="center-content with-padding-top">
							<md-button
								class="md-round md-primary center"
								style="padding: 10px"
								@click="reset"
								:disabled="!isValid"
							>
								{{ $t("reset-password") }}
							</md-button>
						</div>

						<div v-if="!$route.params.conf_code" class="flex with-padding-top">
							<router-link class="center" to="login">
								{{ $t("login-instead") }}
							</router-link>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import ChangeLang from "./layout/layout-components/ChangeLang"

export default {
	name: "Login",
	data() {
		return {
			usernameoremail: undefined,
			error: false,
			password: undefined,
			re_password: undefined
		}
	},
	created() {
		this.$emit("refreshAll", false)
	},
	computed: {
		isValid: function () {
			return this.$route.params.conf_code
				? this.usernameoremail && this.validPassword && this.validRePassword
				: this.usernameoremail
		},
		validPassword: function () {
			if (!this.password) return false
			var res = this.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g)
			return res ? true : false
		},
		validRePassword: function () {
			if (!this.re_password) return false
			if (this.password != this.re_password) return false
			return true
		}
	},
	methods: {
		reset() {
			axios
				.post(process.env.VUE_APP_API_URL + "/api/user/resetPassword", {
					usernameoremail: this.usernameoremail,
					password: this.password,
					resetcode: this.$route.params.conf_code,
					language: localStorage.getItem("lang")
				})
				.then(res => {
					if (!this.$route.params.conf_code)
						this.$notification(
							"success",
							this.$t("reset-password"),
							this.$t("reset-password-success"),
							4000
						)
					else {
						this.$goTo("/login")
						this.$notification("success", this.$t("reset-password"), this.$t("password-changed"), 4000)
					}
				})
				.catch(err => {
					console.error(err)
					this.$processError(this.$t("reset-password"), err.response.data.Message)
					this.error = true
				})
		}
	},
	components: {
		changeLang: ChangeLang
	}
}
</script>

<style scoped lang="scss">
@import "../assets/scss/custom-buttom";
#login {
	margin: 0;
	position: absolute !important;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
}
.center {
	margin: auto;
}
.card {
	min-width: 400px;
}
.card-content {
	display: flex;
	margin-top: 50px;
}
.center-content {
	text-align: center;
}
.flex {
	display: flex;
}
.with-margin-top {
	margin-top: 20px;
}
.with-padding-top {
	padding-top: 20px;
}

.shakingcard {
	animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	transform: translate3d(0, 0, 0);
	backface-visibility: hidden;
	perspective: 1000px;
}
@keyframes shake {
	10%,
	90% {
		transform: translate3d(-1px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(2px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-4px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(4px, 0, 0);
	}
}
</style>
